export default __webpack_public_path__ + "static/media/icon-mail.3e34cc93.svg";